// extracted by mini-css-extract-plugin
export var active = "_bs-2";
export var highlight = "_bs-1";
export var highlightLayer = "_bs-0";
export var issuePopover = "_bs-3";
export var statusIcon = "_bs-4";